import { IAccounts } from '../modules/Users/Accounts/accounts-utils';
import { apiClient, apiEndpoints } from './apiClient';

export type GetManyReturnType = {
  status: string;
  data: IAccounts[];
};

type GetOneReturnType = {
  status: string;
  data: IAccounts;
};

const getUser = async (options?: { active?: boolean}) => {
  const response = await apiClient.get<GetManyReturnType>(apiEndpoints.users, { params: options,});
  return response.data.data;
};

const getUserById = async (id: string) => {
  const response = await apiClient.get<GetOneReturnType>(
    `${apiEndpoints.users}/${id}`
  );
  return response.data.data;
};

export type UserPayload = Partial<IAccounts> & { locationIds?: string[] };

const createUser = async (newUserData: UserPayload) => {
  const response = await apiClient.post<GetOneReturnType>(
    apiEndpoints.users,
    newUserData
  );
  return response.data.data;
};

const updateUser = async (id: string, updateUserData: UserPayload) => {
  const response = await apiClient.patch<GetOneReturnType>(
    `${apiEndpoints.users}/${id}`,
    updateUserData
  );

  return response.data.data;
};

const deleteUser = async (id: string) => {
  const response = await apiClient.delete(`${apiEndpoints.users}/${id}`);
  return response.data.data;
};

const userApi = {
  getUser,
  getUserById,
  createUser,
  updateUser,
  deleteUser,
};

export default userApi;
